import {Component, Vue} from 'vue-property-decorator';

@Component
export default class ColorMixin extends Vue {
    private redColors = {
        '--color-to-apply': '#ba0c2f',
        '--hover-color-to-apply': '#d40f37'
    }
    private blueColors = {
        '--color-to-apply': '#004C97',
        // this hover color is temporary
        '--hover-color-to-apply' : '#00438C'
    }

    get colorToApply(): object {
        const isBusiness = window.location.pathname.includes('business');
        return isBusiness ? this.blueColors : this.redColors;
    }
}